module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    staticClass: "settings-modal",
    attrs: {
      "title": "Settings"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "settings"
  }, [_c('p', [_c('label', {
    staticClass: "input-text"
  }, [_vm._v("\n        North Axis\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy",
      value: (_vm.northAxis),
      expression: "northAxis",
      modifiers: {
        "number": true,
        "lazy": true
      }
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.mapEnabled
    },
    domProps: {
      "value": (_vm.northAxis)
    },
    on: {
      "change": function($event) {
        _vm.northAxis = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('ExpandableDrawer', {
    staticClass: "ground-props-drawer",
    attrs: {
      "title": "Ground Properties"
    }
  }, [_c('p', [_c('label', {
    staticClass: "input-text"
  }, [_vm._v("\n          Floor Offset\n          "), _c('Info', [_vm._v("\n            Specifies the vertical offset between the building floor and the ground plane.\n            Use a value < 0 for buildings with below-grade spaces, or a value > 0 for,\n            e.g., buildings on piers.\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.floor_offset),
      expression: "floor_offset"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.floor_offset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.floor_offset = $event.target.value
      }
    }
  })], 1)]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "input-text"
  }, [_vm._v("\n          Azimuth Angle\n          "), _c('Info', [_vm._v("\n            Direction of the ground plane, in clockwise degrees from the\n            positive y-axis when viewed from above.\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.azimuth_angle),
      expression: "azimuth_angle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.azimuth_angle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.azimuth_angle = $event.target.value
      }
    }
  })], 1)]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "input-text"
  }, [_vm._v("\n          Tilt Slope\n          "), _c('Info', [_vm._v("\n            Slope of the ground plane from horizontal. For example, a value of 1 implies a 45° angle.\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tilt_slope),
      expression: "tilt_slope"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tilt_slope)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tilt_slope = $event.target.value
      }
    }
  })], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Okay")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2aef9e5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/Settings.vue
// module id = 670
// module chunks = 2